G.OMTsettings = {
  /* configuration for Delta DNA, comment out block or remove to disable */
  // DDNA: {
  //   collect: 'https://collect15528grdnt.deltadna.net/collect/api/',
  //   engage: 'https://engage15528grdnt.deltadna.net/',
  //   env: G.BuildEnvironment.production ? '82460680923639031101040657715627' : '82460669990707279764391947015627',
  //   queueInterval: 1000,
  //   ftuxVersion: 1, // this should be a integer
  // },

  /* configuration for cross promotions */
  crossPromo: {
    promoId: 'wonders-of-egypt-match-2',
    showIcon: true,
    worldMapIcon: {
      width: 127,
      height: 127,
    },
  },

  shoutouts: {
    amountTier0: 3,
    amountTier1: 2,
  },

  adFallback_AskFriend: {
    title: {
      style: { style: 'font-white', fontSize: 40 },
      offsetY: 0,
    },
    graphics: {
      evenColourBg: 0xffca93,
      oddColourBg: 0xfee6c4,
    },
  },

  requestHelp: {
    positionals: {
      useTwoPiecePopup: false,
      maskRadius: 25,
      listOffsetX: 0,
      scrollbarOffsetHeight: 0,
    },
  },

  requestMoveHelp: {
    // the index on this array will be the amount of times the current level has been retried - 1
    // if the player has retried the levels more times than there are percentages,
    // we pick the last percentage in the array.
    probabilities: [
      10,
      20,
      30,
      40,
    ],
  },

  friendshipChest: {
    storyChests: [
      'img/friendshipChest/storyFriendshipChest1.png',
      'img/friendshipChest/storyFriendshipChest2.png',
      'img/friendshipChest/storyFriendshipChest3.png',
      'img/friendshipChest/storyFriendshipChest4.png',
      'img/friendshipChest/storyFriendshipChest5.png',
      'img/friendshipChest/storyFriendshipChest6.png',
      'img/friendshipChest/storyFriendshipChest7.png',
    ],
    layoutData: {
      messageHardBackground: 0xffa200,
      cardBackground: 0xFFF1BB,
      chestIsFacingRight: true,
      messageJoined: {
        fontSize: '150px',
        lineSpacing: -20,
        width: 272,
        height: 175,
      },
      bannerMask: {
        x: -301.74,
        y: -9.599999999999994,
        width: 603.48,
        height: 108,
      },
      bannerText: {
        yOffset: -5,
        fontSize: 48,
        offsetDivision: 8,
      },
    },
    maxCards: 50,
    width: 150,
  },

  FTUXSettings: {
    runLevelsUpTo: 10,
  },

  mapChest: {
    startLevel: 10,
    reoccuringLevel: 10,
    formulaChangePoint: 100,
    mapTileSizeInLevels: 13,
    appearanceNodes: [
      [ // level 1 ~ 4
        { x: 271, y: -370 },
        { x: -269, y: -389 },
        { x: -143, y: -466 },
        { x: -50, y: -531 },
        { x: -53, y: -599 },
        { x: -174, y: -617 },
      ],
      [ // 5 ~ 8
        { x: -244, y: -762 },
        { x: 272, y: -806 },
        { x: 211, y: -950 },
        { x: -21, y: -1007 },
        { x: -227, y: -1034 },
        { x: 272, y: -1046 },
      ],
      [ // 9 ~ 13
        { x: -34, y: -1244 },
        { x: -172, y: -1364 },
        { x: 24, y: -1541 },
        { x: -21, y: -1585 },
        { x: 152, y: -1623 },
      ],
    ],
  },

  postcardEvent: { // Data for the postcard event
    eventId: 'valenDay2020', // Event ID for the developer message. Stored in saveState under eventMsg
    eventGift: [{ prize: 'coin', amount: 500 }], // The gift from the developer
    cardData: {
      title: 'Happy Valentine Day!', // String for the title
      cardCaption: 'Share the love:', // String for the caption
      speechText: 'Be my X to my Y', // String for the speech bubble
      promoCaption: 'For the most romantic day of the year, we just want to let you know that we love you.', // Developer's message
      postcardData: [
        { image: 'img/eventPostcard/eventPostcard1.png', speechText: 'Be the Ginger to my Gingy!' },
        { image: 'img/eventPostcard/eventPostcard4.png', speechText: 'Be the icing to my cake!' },
        { image: 'img/eventPostcard/eventPostcard2.png', speechText: 'Be the Ginger to my Gingy!' },
        { image: 'img/eventPostcard/eventPostcard5.png', speechText: 'Be the lock to my key!' },
        { image: 'img/eventPostcard/eventPostcard3.png', speechText: 'Be the Ginger to my Gingy!' },
        { image: 'img/eventPostcard/eventPostcard6.png', speechText: 'Be the milk to my cookies!' },
        { image: 'img/eventPostcard/eventPostcard7.png', speechText: 'Be the salt to my pepper!' },
      ],
      speechBubble: {
        slice: {
          top: 29,
          bottom: 27,
          left: 41,
          right: 30,
        },
      },
      border: {
        offset: { x: 7.5, y: 0 },
        slices: {
          top: 102,
          bottom: 95,
          left: 95,
          right: 107,
        },
        extra: [
          {
            asset: 'popup_eventPostcardRibbon',
            align: [0.0515, 0.05], // from the top left
          },
        ],
      },
    },
    shop: {
      firstTimeBuyerKey: 'first',
      popupKey: 'popup',
      background: 'eventPostcardShopBg',
      chest: 'eventPostcardShopChest',
      coinbar: 'eventPostcardShopCoinbar',
      specialPopupOffer: 'Valentine\'s day special offer',
      popupDimensions: {
        width: 500,
        height: 650,
      },
    },
    worldMapIcon: {
      width: 150,
      height: 150,
    },
  },

  unlimitedLivesMinCap: 15, // The maximum amount of minutes you can get when you get get unlimited lives

  // had to add this since the omt engine doesn't always loads this flag properly from the default config
  unlimitedLivesMinDefaultReward: 15,

  // ===================================================================
  global: {
    gameName: 'Wonders of Egypt Match 2',
    jungleMatch: false,
    customSidePanelBg: true,
    defaultFont: 'Lobster',
    leaderboardName: 'completedLevels',
    gameTracking: {
      active: false,
    },
    window: {
      title: {
        textStyle: 'globalTitleStyle',
      },
    },
    popUpFlexBg: {
      width: 680,
      bottomBgHeight: 300,
    },
  },

  elements: {
    windowNineSlice: {
      top: 112,
      left: 129,
      right: 126,
      bottom: 67,
    },
    leaderboard: {
      disableForBrowsers: ['IE'],
      tabLivesSelected: true,
    },
    gingy: {
      mugshot: {
        x: -50,
        y: 80,
        width: 395,
        height: 395,
      },
      backEyes: {
        x: -11,
        y: -95,
      },
      eyes: {
        x: -5,
        y: -96,
      },
      eyelids: {
        x: 18,
        y: -105,
      },
      mouth: {
        x: 22,
        y: -74,
      },
      body: {
        x: -200,
        y: 10,
      }
    },
    buttonNineSlice: {
      layers: { // Default layers for buttons at regular size
        shadow: 'btn_shadow',
        base: 'btn_base',
        largeDetail: ['btn_pattern1'],
        highlights: 'btn_highlight',
      },
      smallSlice: { // Default slice for small buttons
        left: 22,
        right: 21,
        top: 26,
        bottom: 20,
      },
      largeDetail: { // Default slice for large/detailed buttons
        left: 39,
        right: 42,
        top: 45,
        bottom: 37,
      },
    },
    buttonTintColours: { // Button nine-slice colour definitions
      green: {
        base: 'btn_lightGreen',
        largeDetail: [''],
      },
      blue: {
        base: 'btn_blue',
      },
      red: {
        base: 'small_button_red',
      },
      purple: {
        base: 'btn_blue',
      },
      orange: { // Provides its own layer
        base: 'btn_orange',
        largeDetail: [''],
      },
      gray: {
        base: 'btn_grey',
      },
      lightGreen: {
        base: 'btn_lightGreen',
        largeDetail: [''],
      },
    },
    chestPositioning: {
      closed: {
        top: {
          x: -1,
          y: -18,
        },
      },
      opened: {
        bottom: {
          x: 0,
          y: 0,
        },
        top: {
          x: 25,
          y: -50,
        },
        glow: {
          x: 3,
          y: -42,
        },
      },
    },
    tutorialMsg: {
      fontSize: 45,
      lineSpacing: -10,
    },

    goalOverlayOffset: {
      x: 8,
      y: 2
    },
    dailyReward: {
      title: {
        x: 0,
        y: -255,
        style: 'DailyRewardTitle',
      },
      comeBackTxt: {
        lineSpacing: -10,
      },
    },
    dailyIcon: {
      unlockTxt: {
        fontSize: G.lang === "ja" ? 24 : 30,
      },
      height: 90,
    },
    dailyChallengeIcon: {
      height: 140,
      width: 175,
    },
    dailyMission: {
      ribbonText: {
        yPos: 55,
      },
    },
    mockFacebookFriends: {
      friends: [
        { name: 'Gingy', image: 'friendshipGingy' },
        { name: 'Bubbles', image: 'friendshipBubbles' },
        { name: 'Finn', image: 'friendshipFinn' },
        { name: 'Dolly', image: 'friendshipDolly' },
        { name: 'Shelly', image: 'friendshipShelly' },
        { name: 'Spike', image: 'friendshipSpike' },
      ],
    },
    giftUI: {
      sideGingy: {
        txtBg: {
          scale: {
            x: 0.9,
            y: 1,
          },
        },
        txt: {
          lineSpacing: -20,
          fontSize: '40px',
        },
      },
    },
    worldSidePanelLockedWidget: {
      unlockTxt: {
        fontSize: G.lang === "ja" ? "25px" : "36px"
      },
    },
    highscoreBeaten: {
      continueBtn: {
        x: 0,
        y: 245,
      },
    },
    checkedIconPast: {
      x: 35,
      y: 15,
    },
    checkedIcon: {
      x: 35,
      y: 15,
    },
    mapGift: {
      timer: {
        y: 55,
      },
      width: 150,
    },
    worldMapButtonOrder: {
      left: ['dailyChallenge', 'eventPostcard'],
      right: ['mapGift', 'dailyIcon', 'friendshipChest', 'xPromo'],
      alignXDynamically: true,
    },
    worldMap: {
      mapScale: 1336 / 2508,
      allowHScrolling: true,
      bubbleScale: 0.7,
    },
    worldMapLvlButton: {
      lvlNrText: {
        style: 'worldMapLvlButtonText',
      },
      closedMsg: {
        style: 'lvlButtonCloseMessage',
        x: 560,
        y: 204.5,
        width: 186,
        height: 152,
      },
    },
    UI_MapPanel: {
      starsIcon: {
        x: 0,
        y: 36,
      },
      starsTxt: {
        x: -240,
        y: 43,
        style: 'UIMapStarsTxt',
      },
      coinsBg: {
        x: 0,
        y: 37,
      },
      coinsTxt: {
        x: -40,
        y: 43,
        style: 'UIMapCoinsTxt',
      },
      plusIcon: {
        x: 210,
        y: 37,
      },
      moveTo: {
        ifLifes: {
          stars: -90,
          coins: 120,
        },
        ifNotLifes: {
          stars: -270,
          coins: -50,
        },
      },
      settingsMenu: {
        x: 270,
        y: 40,
        scale: 0.9,
      },
    },
    Window_friendOvertaken: {
      titleTxt: {
        style: 'friendOvertaken',
      },
    },
    Window_mysteryGift: {
      titleOffsetY: 5,
    },
    Window_highscoreBeaten: {
      titleTxt: {
        style: 'highscoreBeaten',
      },
    },
    Window_crossPromo: {
      titleTxt: {
        x: 0,
        y: -240,
      },
      continueBtn: {
        x: 0,
        y: 250,
      },
      continueBtnTxt: {
        x: 0,
        y: 0,
        style: 'XPromoContinue',
      },
    },
    Window_giveUp: {
      levelTxt: {
        style: 'giveUpLevelTxt',
      },
    },
    Window_botOptIn: {
      titleTxt: {
        style: 'BotOptInTitle',
      },
    },
    Window_notEnoughLives: {
      livesNrTxt: {
        x: 0,
        y: -60,
      },
      coinsTxt: {
        x: 23,
        y: -282,
        style: 'font-white',
      },
      buyLifeButton_coinTxt: {
        style: 'font-white',
      },
    },
    Window_taskSlider: {
      taskTxt: {
        y: 50,
        style: 'taskText',
      },
      goal: {
        style: 'taskGoal',
      },
    },
    Window_newsHomeScreen: {
      button: {
        shouldPulse: true,
        x: 0,
        y: 215,
      },
      continueBtn: {
        x: 0,
        y: 295,
      },
      continueBtnTxt: {
        x: 0,
        y: 295,
      },
    },
    Window_shop2: {
      isShowing3hGift: true,
      scrollHeightOffset: -10,
    },
    Window_treasureHuntEvent: {
      bgSize: 300,
    },
    UI_Life: {
      livesNrTxt: {
        x: 0,
        y: 0,
      },
      timerTxt: {
        x: 85,
        y: 7,
        style: 'UILifeTimerTxt',
      },
      unlimitedTimerTxt: {
        x: 90,
        y: 7,
        style: 'UILifeUnlimited',
      },
      timerMaxTxt: {
        x: 80,
        y: 7,
        style: 'UILifeTimerMax',
      },
    },
    UI_PointsCounter: {
      text: {
        style: 'UIPointsTxt',
      },
    },
    UI_BoosterButton: {
      amount: {
        style: 'UIBoosterAmount',
      },
    },
    UI_StartBoosterButton: {
      amountTxt: {
        style: 'font-purple',
      },
    },
    taskCollectPanels: {
      amount: {
        style: {
          style: 'font-purple',
        },
      },
    },
    UI_GoalPanelCollect: {
      panelNr: {
        style: 'UIGoalPanelNr',
      },
    },
    UI_GoalPanelPoints: {
      labelTxt: {
        style: 'UIGoalPanelPointsLabel',
      },
      pointsCounter: {
        x: 405,
        y: 110,
        style: 'UIGoalPanelPointAmount',
      },
    },
    UI_TopBar: {
      movesTxt: {
        x: 134,
        style: 'UITopMovesLabel',
      },
      movesAmountTxt: {
        x: 134,
        style: 'UITopMovesAmount',
      },
    },
    gifts: {
      shineOffsetY: -55,
      useGiftTrim: false,
    },
    // these colors use { GIFT_COLORS } from "../../js/Elements/Windows/GiftUI/GiftGraphic"
    dailyRewardCalendar: {
      doubleable: true,
      days: [
        // top left
        {
          gifts: [['coin', 200]],
          boxIcon: [],
        },
        // top middle
        {
          gifts: [['booster#2', 1]],
          boxIcon: [
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Yellow',
              pos: [0, 0],
              useFullGift: false,
            },
          ],
        },
        // top right
        {
          gifts: [['booster#7', 1]],
          boxIcon: [
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Yellow',
              pos: [15, -8],
              scale: [0.85, 0.85],
              useFullGift: false,
            },
            {
              giftType: 2,
              boxTint: 'Light_Blue',
              ribbonTint: 'Red',
              pos: [-18, 10],
              scale: [0.9, 0.9],
            },
          ],
        },
        // middle left
        {
          gifts: [['booster#5', 1]], // #5/#6 fixed in dailyRewardMgr
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Red',
              ribbonTint: 'Green',
              pos: [20, -10],
              scale: [0.9, 0.9],
            },
            {
              giftType: 1,
              boxTint: 'Light_Blue',
              ribbonTint: 'Purple',
              pos: [-20, 8],
              scale: [0.85, 0.85],
            },
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Yellow',
              pos: [15, 20],
              scale: [0.7, 0.7],
            },
          ],
        },
        // middle center
        {
          gifts: [['booster#1', 1]],
          boxIcon: [
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Yellow',
              pos: [20, -10],
              scale: [0.8, 0.8],
              useFullGift: false,
            },
            {
              giftType: 2,
              boxTint: 'Green',
              ribbonTint: 'Pink',
              pos: [-25, 7],
              scale: [1, 1],
            },
            {
              giftType: 2,
              boxTint: 'Light_Blue',
              ribbonTint: 'Red',
              pos: [25, 20],
              scale: [0.7, 0.7],
            },
          ],
        },
        // middle right
        {
          gifts: [['booster#8', 1]],
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Red',
              ribbonTint: 'Green',
              pos: [0, -9],
              scale: [0.85, 0.85],
            },
            {
              giftType: 1,
              boxTint: 'Red',
              ribbonTint: 'Light_Blue',
              pos: [-28, 5],
              scale: [0.8, 0.8],
            },
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Pink',
              pos: [28, 5],
              scale: [0.75, 0.75],
            },
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Yellow',
              pos: [-5, 19],
              scale: [0.8, 0.8],
            },
          ],
        },
        // bottom
        {
          gifts: [
            ['booster#5', 1], // #5/#6 fixed in dailyRewardMgr
            ['booster#8', 1],
          ],
          boxIcon: [
            // leftmost
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Pink',
              pos: [-90, -20],
              scale: [0.75, 0.75],
            },
            // rightmost
            {
              giftType: 2,
              boxTint: 'Red',
              ribbonTint: 'Pink',
              pos: [90, -20],
              scale: [0.75, 0.75],
            },
            // second from right
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Yellow',
              pos: [55, -10],
              scale: [0.8, 0.8],
              useFullGift: false,
            },
            // second frm left
            {
              giftType: 1,
              boxTint: 'Pink',
              ribbonTint: 'Light_Blue',
              pos: [-55, -10],
              scale: [0.8, 0.8],
            },
            // center
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Red',
              pos: [0, 0],
              scale: [1.2, 1.2],
            },
          ],
        },
      ],
    },
  },
};